/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import { Space } from '@kargotech/tms-ui/components';
import chroma from 'chroma-js';
import React, { useContext } from 'react';
import styled from 'styled-components';

import { AppContext } from '~/contexts/AppProvider';
import { NavigationContext } from '~/contexts/NavigationProvider';

const MinimalWrapper = styled.div`
  background-color: ${(props) => chroma(props.theme.colors.grey).alpha(0.5) as string};
  height: 100vh;
  overflow: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;
`;

const ContentBox = styled(Space)`
  background-color: ${(props) => props.theme.colors.light};
  padding: 3rem;
  width: 100%;
  max-width: 37rem;
`;

const Header = styled(Space)`
  margin-bottom: 1rem;
`;

const LanguageContainer = styled.div`
  .ant-select-arrow{
    color: ${(props) => props.theme.colors.primary};
  }
  .ant-form-item-control-input-content{
    display: contents;
  }
  .ant-select-selection-item{
    color: ${(props) => props.theme.colors.primary};
  }
`;

const LogoContainer = styled.div`
  img {
    width: 15rem;
  }
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${LanguageContainer}{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
  .icon-item{
    color: ${(props) => props.theme.colors.primary};
  }
`;

const Title = styled.div`
  & > h2 {
    font-weight: bold;
    margin: 0;
  }
`;

const MinimalLayout = ({ children }) => {
  const { title, subtitle, showLogo } = useContext(NavigationContext);
  const { logo } = useContext(AppContext);

  return (
    <MinimalWrapper>
      <ContentBox direction="vertical" size="small">
        {(showLogo || title || subtitle) && (
          <Header direction="vertical" size="middle">

            <LogoContainer>
              {showLogo && (<img alt="Kargo Vendor Central" src={logo} />)}
            </LogoContainer>

            {(title || subtitle) && (
              <Title>
                {title && <h2>{title}</h2>}
                {subtitle && <span>{subtitle}</span>}
              </Title>
            )}
          </Header>
        )}
        {children}
      </ContentBox>
    </MinimalWrapper>
  );
};

export default MinimalLayout;
